<template>
  <div style="overflow:auto;">
    <div class="nav-bar-container">
      <div class="nav-bar clearfix">
        <div class="summary-items">
          <div
            v-if="showTendersTable"
            class="summary-item"
            @click="scrollMeTo('tenderBids')"
          >
            <span class="summary-badge summary-badge__dark">{{ tenderBids.length }}</span>
            <span class="summary-item__title">{{ $t('dashboard.tendersInProgress') }}</span>
          </div>
          <div
            v-if="showProjectsTable"
            class="summary-item"
            @click="scrollMeTo('vendorProjects')"
          >
            <span class="summary-badge summary-badge__normal">{{ vendorProjects.length }}</span>
            <span class="summary-item__title">{{ $t('dashboard.activeProjects') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="showTendersTable"
      ref="tenderBids"
    >
      <TendersBidTable
        :vendorId.sync="vendorId"
        :model.sync="tenderBids"
        :isVendorAccount="isVendorAccount"
        :isTenderRep="isTenderRep"
      />
    </div>
    <div
      v-if="enableProjectFeature"
      v-show="showProjectsTable"
      ref="vendorProjects"
    >
      <VendorProjectsTable
        heading="Projects"
        :model.sync="vendorProjects"
      />
    </div>
    <!-- hotfix HKLDCMS-17266 -->
    <div class="work-permit-container">
      <WorkPermits v-if="enableWorkPermitsFeature" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TendersBidTable from '@/modules/tenders/TendersBidTable'
import VendorProjectsTable from '@/modules/projects/VendorProjectsTable'
import WorkPermits from '@/modules/dashboards/WorkPermits'
import CmsModulesStatusMixin from '@/modules/CmsModulesStatusMixin'
import EventBus from '@/utils/eventBus'
import i18n from '@/utils/i18n'
import notification from '@/utils/notification'
import router from '@/router'
import { aclHelper } from '@/utils/aclHelper'
import { getVendorLoginDataCheck } from '@/api/users/request'
import {
  isContractor,
} from '../services'

export default {
  name: 'VendorHomePage',
  components: {
    TendersBidTable,
    VendorProjectsTable,
    WorkPermits,
  },
  mixins: [CmsModulesStatusMixin],
  async beforeRouteEnter (_, __, next) {
    if (aclHelper.hasUpdateVendorContactsAccess() ||
      aclHelper.hasStandaloneWpAccess(isContractor())) {
      next()
      return
    }
    const { isExistingData } = await getVendorLoginDataCheck()
    if (isExistingData) {
      next()
    } else {
      EventBus.emit('module_loading_stopLoading')
      notification.fireNotification(false, i18n.t('error.invalidLogin'))
      next(false)
    }
  },
  data () {
    return {
      workPermits: [],
      tenderBids: [],
      vendorProjects: [],
      loadingTenderTable: false,
    }
  },
  computed: {
    ...mapGetters('user', ['currentUser', 'currentUserContact']),
    ...mapGetters('regions', ['enableWorkPermitsFeature']),
    vendorId () {
      return router.currentRoute.params.id
    },
    showProjectsTable () {
      return this.vendorProjects && this.vendorProjects.length > 0 &&
        (aclHelper.hasProjectsAccess(true) || aclHelper.hasWorkPermitAccess(true))
    },
    showTendersTable () {
      return this.enableTenderFeature && (this.isVendorAccount || this.isTenderRep)
    },
    isVendorAccount () {
      return aclHelper.hasTendersAccess(true)
    },
    isTenderRep () {
      return aclHelper.hasTenderRepAccess(true)
    },
  },
  methods: {
    scrollMeTo (refName) {
      const element = this.$refs[refName]
      const top = element.offsetTop
      $('html, body').animate({ scrollTop: top }, 200)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/dashboard/style.scss';

.summary-items {
  display: inline;
}
</style>
<style lang="scss">
.work-permit-container {
  padding: 15px 24px;
  max-width: 1440px;
  margin: 0 auto;

  .dashboard__table {
    & thead {
      background-color: #f8f8f8!important;
    }
    &--body:nth-child(odd) {
      background-color: #fff!important;
    }
    &--body:nth-child(even) {
      background-color: #ebebeb33!important;
    }
  }
}

</style>
